import { RootState } from "@/store/types";
import { GetterTree } from "vuex";
import { StatisticState } from "./types";

export const getters: GetterTree<StatisticState, RootState> = {
  whatsappStatisticDetail: (state) => state.whatsappStatisticDetail,
  whatsappStatisticDetailFlag: (state) => state.whatsappStatisticDetailFlag,
  whatsappStatisticGroup: (state) => state.whatsappStatisticGroup,
  whatsappGroupBy: (state) => state.whatsappGroupings.whatsappGroup,
  whatsappGroupByOptionally: (state) => state.whatsappGroupings.whatsappGroupByOptionally,
};
